import React from 'react';
import Skeleton from 'src/components/Skeleton/Skeleton';

const DOCUMENT_SKELETON_COUNT: number = 6;

const DocumentsSkeletonGrid = () => (
  <div className="docs-repeater-scroll">
    <div className="docs-repeater-grid">
      {Array.from({ length: DOCUMENT_SKELETON_COUNT }, (_, index: number) => (
        <div key={`document-skeleton-${index}`} className="docs-repeater-cell">
          <Skeleton variant="rect" width="100%" height="14rem" />
          <div style={{ marginTop: '0.6rem' }}>
            <Skeleton variant="text" width="80%" />
          </div>
          <div style={{ marginTop: '0.3rem' }}>
            <Skeleton variant="text" width="50%" />
          </div>
        </div>
      ))}
    </div>
  </div>
);

export default DocumentsSkeletonGrid;
